import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { History } from "lucide-react";
import { getRecentlyViewed } from "../lib/recentlyViewed";

export default function RecentlyViewed({ excludeId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems(getRecentlyViewed().filter((c) => c.id !== excludeId).slice(0, 4));
  }, [excludeId]);

  if (!items.length) return null;
  return (
    <section className="container-x py-12" data-testid="recently-viewed">
      <div className="flex items-center gap-2 mb-5">
        <History className="h-4 w-4 text-[color:var(--brand-amber)]" />
        <h2 className="font-display text-xl tracking-tight">Recently viewed</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {items.map((c) => (
          <Link
            key={c.id}
            to={`/courses/${c.slug}`}
            className="rounded-lg border border-border bg-card p-3 flex gap-3 items-center card-hover"
            data-testid={`recent-${c.slug}`}
          >
            <img src={c.image_url} alt="" className="h-12 w-16 rounded object-cover shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold line-clamp-2">{c.title}</div>
              <div className="text-xs text-muted-foreground mt-0.5">${(c.price || 0).toFixed(2)}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
